import SelectorEngine from '../../utils/dom/selector-engine';
import Modal from '../../components/Modal';
import EventHandler from '../../utils/dom/event-handler';
import Manipulator from '../../utils/dom/manipulator';
import Request from '../../utils/request';
import attachValidation from '../../utils/form-validation';
import { getDataFromForm } from '../../utils/misc';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';

class EditImapirmentDetails {
	constructor() {
		this.disabilityStatus = undefined;
		this.disabilityTennisCategories = [];
		this._container = SelectorEngine.findOne('.js-edit-coach-details-impairment-details');

		if (this._container) {
			this.init();
		}
	}

	init() {
		this._form = SelectorEngine.findOne('#lta-coach-details__edit-impairment-details-form', this._container);

		this._exitModal = new Modal(SelectorEngine.findOne('#coach-details-impairment-details-exit'), {});

		this._cancelCta = SelectorEngine.findOne('.lta-coach-details__edit-impairment-details-back', this._container);
		this._cancelCta.addEventListener('click', () => this._exitModal.show());

		const popupCancel = SelectorEngine.findOne('.lta-coach-details__edit-impairment-details-continue', this._container);
		popupCancel.addEventListener('click', () => this._exitModal.hide());

		const popupContinue = SelectorEngine.findOne('.lta-coach-details__edit-impairment-details-exit', this._container);
		popupContinue.addEventListener('click', (event) => this.backToUrl(event));

		this._errorContainer = SelectorEngine.findOne('.lta-edit-impairment-error-container', this._container);
		this._errorText = SelectorEngine.findOne('.error-text', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});

		this._form.addEventListener('change', () => {
			this.showHideSection();
		});

		this.isDisability = SelectorEngine.findOne('.lta-disability-status', this._container);
		this.isDisabilityStatus = SelectorEngine.find('input[name=disabilityTennis]', this.isDisability);
		this.disabilityCriteria = SelectorEngine.findOne('.lta-disability-criteria', this._container);
		this.disabilityList = SelectorEngine.find('input[type="checkbox"]', this.disabilityCriteria);

		for (const status of this.isDisabilityStatus) {
			if (status.checked) {
				this.disabilityStatus = status.value;
			}
			status.addEventListener('change', (event) => {
				this.disabilityStatus = event.target.value;
				this.showHideSection();
			});
		}

		this.showHideSection();

		for (const list of this.disabilityList) {
			if (list.checked) {
				this.disabilityTennisCategories.push(list.value);
			}
			EventHandler.on(list, 'change', (event) => {
				this.handleCheckboxClick(event);
			});
		}
		this._validationErrorText = SelectorEngine.findOne('.lta-text-input--error', this.disabilityCriteria);

		this._saveCta = SelectorEngine.findOne('.save-impairment-cta', this._container);
		this._saveCta.addEventListener('click', (event) => {
			this.triggerSubmit();
		});

		this.fv = attachValidation(this._form, {
			disabilityTennis: {
				validators: {
					notEmpty: {
						message: 'Please select an option'
					}
				}
			}
		});
		this.fv.on('core.form.valid', () => {
			this.triggerSubmit(this._form);
		});
	}

	showHideSection() {
		if (this.disabilityStatus === 'Yes') {
			this.disabilityCriteria.classList.remove('u-hidden');
		} else {
			this.disabilityCriteria.classList.add('u-hidden');
			this.disabilityList.map((value) => (value.checked = false));
			this.disabilityTennisCategories = [];
		}
	}

	handleCheckboxClick(event) {
		this._validationErrorText.textContent = '';
		this.disabilityCriteria.classList.remove('validation-error')
		if (event.target.checked) {
			this.disabilityTennisCategories.push(event.target.value);
		} else {
			this.disabilityTennisCategories = this.disabilityTennisCategories.filter((value) => value !== event.target.value);
		}
	}

	async triggerSubmit(form) {
		const dataObject = getDataFromForm(form);
		if (this.disabilityStatus === 'No') {
			this.disabilityTennisCategories = [];
		} else {
			if (this.disabilityTennisCategories.length === 0) {
				this._validationErrorText.textContent = 'Please select an option';
				this.disabilityCriteria.classList.add('validation-error')
				return;
			}
			stopLoadingAnimation();
		}
		startLoadingAnimation(true);
		const payload = {
			updateCoachDetailsRequest: {
				impairmentSpecificSessions: {
					disabilityTennisCategory: this.disabilityTennisCategories,
					disabilityTennisFlag: this.disabilityStatus
				}
			}
		};
		try {
			const url = `/api/coachdetails/update`;
			const responseData = await Request.post(url, payload);

			const { success } = responseData;
			if (success) {
				const redirectUrl = Manipulator.getDataAttribute(this._container, 'redirect-url');
				window.location.href = redirectUrl;
			} else {
				this._errorContainer.classList.remove('u-hidden');
				this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			}
		} catch {
			this._errorContainer.classList.remove('u-hidden');
			this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			this._errorContainer.scrollIntoView();
		} finally {
			stopLoadingAnimation();
		}
	}

	backToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const globalEditImpairmentDetails = new EditImapirmentDetails();

export default globalEditImpairmentDetails;
